/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/oferta-courier'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import CourierOferta from '@routes/StaticPages/LegalPages/CourierOferta';

export const Route = createFileRoute('/oferta-courier')({
  staticData: { layout: { withoutHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute component={CourierOferta} path='/oferta-courier' />
  )
});
